/* eslint-disable */
import { IYearEndFormUpload } from 'src/interfaces';
import { getStorageValue } from 'src/hooks/useLocalStorage';
import axios, { AxiosError } from 'axios';
import http from './http';

class YearEndFormsService {
  static patchYearEndForm(data: any) {
    return http.patch('/year-end-forms/upload', data, {
      headers: { companyId: data.companyId },
    });
  }

  static getYearEndFormProgress() {
    return http.get('/year-end-forms/upload-progress');
  }

  static getYearEndFormsByEmployee(employeeId: any) {
    return http.get(`/year-end-forms/employee-form/${employeeId}`);
  }

  static getW2YearFormsList(companyId: string) {
    return http.get('/year-end-forms/years', {
      headers: { companyId },
    });
  }

  static getW2YearFormsListByYear(companyId: string, year: string, formType: string) {
    return http.get(`/year-end-forms?year=${year}&formType=${formType}`, {
      headers: { companyId },
    });
  }

  static getSelectedyearEndFormsList(companyId: string, year: string, formType: string) {
    return http.get(`/year-end-forms/selected-forms?year=${year}&formType=${formType}`, {
      headers: { companyId },
    });
  }

  static getEmployeeDetailYearEndForm(companyId: string, year: string, employeeId: string, controlNumber: string) {
    return http.get(`/year-end-forms/details?year=${year}&employeeId=${employeeId}&controlNumber=${controlNumber}`, {
      headers: { companyId },
    });
  }

  static editEmployeeDetailYearEndForm(companyId: string, data: any) {
    const headers = {
      companyId,
    };
    return http
      .put('/year-end-forms/form', data, { headers })
      .then(response => response.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }
  // static editEmployeeDetailYearEndForm(companyId: string, data: any) {
  //   const headers = {
  //     companyId,
  //   };
  //   return http
  //     .put('/year-end-forms/form', data, { headers })
  //     .then(response => response.data)
  //     .catch((err: Error | AxiosError) => {
  //       if (axios.isAxiosError(err)) {
  //         throw new Error(err.response?.data?.message);
  //       } else {
  //         return err;
  //       }
  //     });
  // }

  static w2FormConfig() {
    return http.get(`/year-end-forms/config`);
  }

  static w2FormConfigPost(enabled: boolean) {
    return http.post(`/year-end-forms/config`, { enabled: enabled });
  }

  static getYearEndFormsDistributionGraphic(companyId: string, year: string, formType: string) {
    return http.get(`/year-end-forms/distribution-graphic?year=${year}&formType=${formType}`, {
      headers: { companyId },
    });
  }

  static getW2YearEndFormPdf(
    companyId: string,
    controlNumber: string,
    downloadFile = true,
    employeeId: string,
    year: string
  ) {
    return `${process.env.REACT_APP_API_URL}year-end-forms/generate-pdf?token=${getStorageValue(
      'accessToken',
      null
    )}&download=${downloadFile}&controlNumber=${controlNumber}&companyId=${companyId}&employeeId=${employeeId}&year=${year}`;
  }

  static get1095YearEndFormPdf(
    companyId: string,
    controlNumber: string,
    downloadFile = true,
    employeeId: string,
    year: string
  ) {
    return `${process.env.REACT_APP_API_URL}health-coverage-statement/generate-pdf?token=${getStorageValue(
      'accessToken',
      null
    )}&download=${downloadFile}&controlNumber=${controlNumber}&companyId=${companyId}&employeeId=${employeeId}&year=${year}`;
  }
}
export default YearEndFormsService;
